import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { StreamHistory } from '../../../_models';
import { AuthenticationService, NotificationService, EnvService, StreamHistoryService, StreamKeywordService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-stream-history',
  templateUrl: './stream-history.component.html'
})
export class StreamHistoryComponent implements OnInit {
  streamList: Array<StreamHistory> = [];
  loading = false;
  processing = false;
  //pagination
  itemsPerPage = 20;
  pagingList = [20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = true;
  maxPageSize: number;

  filterable = {
    fromDate: '',
    toDate: new Date().toISOString().substring(0, 10),
    panOutState: '',
    shortCode: null,
    keyword: null,
    operator: ''
  };

  keywordList = {};
  shortCodeList = {};
  shortCodeFilterList = [];
  operatorList: any = [];
  panOutStateList = {};

  exporting = false;
  downloadUrl = '';
  selectedCountry = '';

  constructor(private authSvc: AuthenticationService,
    private envSvc: EnvService,
    private keywordSvc: StreamKeywordService,
    private streamHistorySvc: StreamHistoryService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 7);
    this.filterable.fromDate = dte.toISOString().substring(0, 10);
    this.loadPanOutStates();
    this.loadShortCodes();
  }

  search() {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 7);
    this.filterable = {
      fromDate: dte.toISOString().substring(0, 10),
      toDate: new Date().toISOString().substring(0, 10),
      panOutState: '',
      shortCode: null,
      keyword: null,
      operator: ''
    };
    this.keywordList = {};
    this.operatorList = [];
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onClear() {
    this.filterable.shortCode = Object.keys(this.shortCodeList)[0];
    this.filterable.operator = '';
    this.filterable.keyword = null;
    this.keywordList = {};
    this.operatorList = [];
    this.changeShortCode(this.filterable.shortCode);
  }

  export() {
    this.exporting = true;
    let params = this.formParam();
    this.streamHistorySvc.export(params)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  changeShortCode(shortCode) {
    this.operatorList = [];
    this.keywordList = [];
    this.filterable.keyword = null;
    this.filterable.operator = '';
    if (shortCode) {
      this.keywordList = this.shortCodeList[shortCode];
    }
  }

  changeKeyword(keyword) {
    this.operatorList = [];
    this.filterable.operator = '';
    if (keyword) {
      this.operatorList = keyword.value;
    }
  }

  private loadPanOutStates() {
    this.envSvc.getPanOutStates().pipe(first()).subscribe(data => {
      this.panOutStateList = data.data;
    });
  }

  private loadShortCodes() {
    this.keywordSvc.getSelection().pipe(first()).subscribe(data => {
      this.shortCodeList = data.data;
      console.log(this.shortCodeList);
      this.shortCodeFilterList = Object.keys(this.shortCodeList);
      this.filterable.shortCode = this.shortCodeFilterList[0];
      this.changeShortCode(this.filterable.shortCode);
    });
  }

  private loadPage(page = null) {
    this.loading = true;
    this.emptyResult = false;
    this.streamList = [];
    let params = this.formParam(page);
    // get page of items from api
    this.streamHistorySvc.getAll(params).pipe(first()).subscribe(data => {
      if (data && data.data) {
        this.loading = false;
        this.streamList = data.data.list;
        this.totalItems = data.data.total;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      fromDate: formatDate(this.filterable.fromDate, 'yyyyMMdd', 'en'),
      toDate: formatDate(this.filterable.toDate, 'yyyyMMdd', 'en'),
      panOutState: this.filterable.panOutState,
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword == null ? "" : this.filterable.keyword.key,
      operator: this.filterable.operator,
    }
    console.log(params);

    return params;
  }

}
